import { render, staticRenderFns } from "./waveEChart.vue?vue&type=template&id=547f7961&scoped=true"
import script from "./waveEChart.vue?vue&type=script&lang=js"
export * from "./waveEChart.vue?vue&type=script&lang=js"
import style0 from "./waveEChart.vue?vue&type=style&index=0&id=547f7961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f7961",
  null
  
)

export default component.exports